import {
  Component,
  ComponentRef,
  signal,
  ViewChild,
  ViewContainerRef,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { DrawerService } from '@shared/services/drawer-service';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

import { DrawerModule } from 'primeng/drawer';
import { Type } from '@angular/core';

type DrawerData = {
  header?: string;
} & Record<string, unknown>;

@Component({
  selector: 'app-drawer-host',
  imports: [DrawerModule],
  template: `
    <p-drawer
      [(visible)]="visible"
      [position]="position"
      [closable]="true"
      [modal]="modal"
      [dismissible]="true"
      (onHide)="onHide()"
      [style]="{
        width: '30dvw',
        minWidth: '350px',
      }">
      <ng-template #header>
        <h3 class="text-xl font-bold">{{ headerTitle() }}</h3></ng-template
      >
      <ng-template #drawerContainer></ng-template>
    </p-drawer>
  `,
})
export class DrawerHost {
  @ViewChild('drawerContainer', { read: ViewContainerRef, static: true })
  drawerContainer!: ViewContainerRef;
  headerTitle = signal('');

  visible = false;
  position: 'left' | 'right' | 'top' | 'bottom' = 'right';
  modal = true;
  private currentComponent?: ComponentRef<unknown>;
  private drawerService = inject(DrawerService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);
  private launchUrl = '';

  constructor() {
    // Subscribe to open requests from the service
    this.drawerService.openDrawer$.subscribe(({ component, data, position, modal }) => {
      this.open(
        component as Type<unknown>,
        data as DrawerData,
        position as 'left' | 'right' | 'top' | 'bottom',
        modal as boolean | undefined
      );
    });

    this.drawerService.closeDrawer$.subscribe(() => this.close());

    // Close the drawer when navigating away from the page that opened it
    this.router.events
      .pipe(filter((event): event is NavigationStart => event instanceof NavigationStart))
      .subscribe(event => {
        if (this.visible && event.url !== this.launchUrl) {
          this.close();
        }
      });
  }

  open(
    component: Type<unknown>,
    data?: DrawerData,
    position: 'left' | 'right' | 'top' | 'bottom' = 'right',
    modal = true
  ) {
    this.drawerContainer.clear();
    this.position = position;
    this.modal = modal;
    this.headerTitle.set(data?.header || '');

    this.currentComponent = this.drawerContainer.createComponent(component);
    if (data && this.currentComponent.instance) {
      Object.assign(this.currentComponent.instance, data);
    }

    this.launchUrl = this.router.url;
    this.visible = true;
  }

  close() {
    // Defer the change to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.visible = false;
      this.cdr.detectChanges();
    });
  }

  onHide() {
    // Clear the container when drawer is hidden
    this.drawerContainer.clear();
    this.currentComponent = undefined;
    this.drawerService.notifyClosed();
  }
}
